function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import mediaQueryBreakpoints from '../../base/grid'; // converting "1440px" to 1440

var MEDIA_QUERY_BREAKPOINTS = Object.entries(mediaQueryBreakpoints().global).reduce(function (acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  acc[key] = parseInt(value.split('px')[0], 10);
  return acc;
}, {});

function processQuery(query) {
  switch (query) {
    case '>mobile':
      return "(min-width: 321px)";

    case '>=mobile':
      return "(min-width: 320px)";

    case '>tablet':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth + 1, "px)");

    case '>=tablet':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth, "px)");

    case '>desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth + 1, "px)");

    case '>=desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth, "px)");

    case '>lrg-desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth + 1, "px)");

    case '>=lrg-desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth, "px)");

    case '<mobile':
      return "(max-width: 319px)";

    case '<=mobile':
      return "(max-width: 320px)";

    case '<tablet':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth - 1, "px)");

    case '<=tablet':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth, "px)");

    case '<desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth - 1, "px)");

    case '<=desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth, "px)");

    case '<lrg-desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth - 1, "px)");

    case '<=lrg-desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth, "px)");

    default:
      throw new Error("Unrecognised arg in `media('".concat(query, "')`, please read the `media` function here in fe-brary/src/js/emotion/utility/media.js to see supported args."));
  }
}

function media() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  if (arguments.length < 1) {
    throw new Error('Must supply at least one argument to `media`.');
  }

  var processedQueries = queries.map(function (query) {
    return processQuery(query);
  }); // currently multiple processedQueries are just joined by logical AND

  return "@media".concat(processedQueries.join(' and '));
}

export default media;